var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-card',{attrs:{"title":`Invoice #${_vm.invoice.invoiceNum}`,"cancel-text":'Close'}},[_c('invoice',{attrs:{"invoice":_vm.invoice},on:{"print":function($event){return _vm.$emit('close')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }